module.exports = __webpack_public_path__ + "static/scale-model-of-dallas-holocaust-museum-in-dallas-texas-2b4f759692d230078b39069abeee59f0.png";